import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  fieldContent: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 15,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
  },
}))

export default useStyles
